export default {

  getMessageSide(isSender) {
    return isSender ? 'right' : 'left'
  },

  isFullUrl(url) {
    return /^https?:\/\//i.test(url)
  },

  ensureJpgExtension(name) {
    return name.toLowerCase().endsWith('.jpg') ? name : `${name}.jpg`
  },

}
